import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import { MatDialog } from '@angular/material';
import {UserAuthentication} from '../../../service/restAngular/user-authentication';
import {SuccessResetComponent} from '../success-reset/success-reset.component';
import {RestAngularConfig} from '../../../service/restAngular/rest-angular-config';
import {DialogState, ScrollBarData} from "../../shared/scroll-bar-data";
import {FormService} from "../../../service/FormService";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  providers: [UserAuthentication, SuccessResetComponent, FormService],
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent {
  email: string;
  notExist = false;

  @ViewChild('forgotPassword') form: NgForm;

  constructor(public dialog: MatDialog,
              private userAuthentication: UserAuthentication,
              private formService: FormService) { }

  submitEmail() {
    this.formService.setTouched(this.form);
    if (this.form.touched && this.form.valid) {
      this.userAuthentication.resetPassword(this.email).subscribe((res) => {
        this.dialog.closeAll();
        setTimeout(() => {
          const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
          const matDialogRef = this.dialog.open(SuccessResetComponent);
          ScrollBarData.updateBodyWidth(DialogState.OPEN, hasScrollbar);
          matDialogRef.afterClosed().subscribe(() => ScrollBarData.updateBodyWidth(DialogState.CLOSE));
        }, 500);
      });
      RestAngularConfig.RestangularProvider.addErrorInterceptor((resp) => {
        if (resp.status >= 400) {
          if (resp.text().indexOf('This email address does not exist') > -1) {
            this.notExist = true;
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/login-signup/forgot-password/forgot-password.component.ts